import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Cyrus No-BG Notes" mdxType="SEO" />
    <h3 {...{
      "id": "cyrus-ch1"
    }}>{`Cyrus Ch.1`}</h3>
    <p>{`After getting cutscened outside the palace, go back in and turn right for a `}<strong parentName="p">{`Thunder S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`During the scrutinize mission, scrutinize the guard by the screen split for a `}<strong parentName="p">{`Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Quiz: Option 1, Option 2`}</em><br parentName="p"></br>{`
`}{`When the dungeon opens, go to the south screen and scrutinize the girl in the plaza for a `}<strong parentName="p">{`Light M`}</strong></p>
    <h5 {...{
      "id": "weapon-shop"
    }}>{`Weapon Shop`}</h5>
    <p>{`Buy Quartz Rod and equip`}</p>
    <p>{`Subterranean Study: Kill 2 encounters for 10 JP. Pick `}<strong parentName="p">{`Light S`}</strong>{` to the far right of the boss trigger.`}</p>
    <h4 {...{
      "id": "russell"
    }}>{`Russell`}</h4>
    <p><em parentName="p">{`Heal when below 40 HP`}</em><br parentName="p"></br>{`
`}{`1. Fireball`}<br parentName="p"></br>{`
`}{`2. Thunder S`}<br parentName="p"></br>{`
`}{`3. Light S`}<br parentName="p"></br>{`
`}{`4. Icewind`}<br parentName="p"></br>{`
`}{`5. Staff x3`}<br parentName="p"></br>{`
`}{`6. Light S`}<br parentName="p"></br>{`
`}{`7. Staff`}<br parentName="p"></br>{`
`}{`8. Staff x3`}<br parentName="p"></br>{`
`}{`9. Fireball x4`}</p>
    <p>{`Go to The Whistlewood in North Atlasdam Flats and pick up `}<strong parentName="p">{`$1500`}</strong>{` red chest.`}<br parentName="p"></br>{`
`}{`Kill one of these encounters with `}<strong parentName="p">{`Light M`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul">{`2 Flatlands Froggen IV, 2 Spud Bugs (need 2 JP extra)`}</li>
      <li parentName="ul">{`2 Flatlands Froggen V, 2 Spud Bugs`}</li>
      <li parentName="ul">{`5 Spud Bugs`}</li>
      <li parentName="ul">{`Anything with a Cait`}</li>
    </ul>
    <h5 {...{
      "id": "skills"
    }}>{`Skills`}</h5>
    <p>{`Cyrus: Lightning Blast, Firestorm, Evasive Maneuvers`}</p>
    <p>{`Go to `}<strong parentName="p">{`Noblecourt`}</strong>{`, Scrut & Pick `}<strong parentName="p">{`Thunder L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`, go to `}<strong parentName="p">{`Rippletide`}</strong>{`. `}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Thunder L`}</p>
    <p>{`You have 2 M Stones to use for random battles (1 before Quarrycrest).`}</p>
    <p>{`Head to Merchant Shrine`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1200`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Stonegard`}</strong></p>
    <p>{`Get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`. Head to `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Old Coin`}</strong>{`, tag `}<strong parentName="p">{`Sunshade`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Enter `}<strong parentName="p">{`Quarrycrest`}</strong>{`, start Cyrus 2.`}</p>
    <h3 {...{
      "id": "cyrus-ch2-start"
    }}>{`Cyrus Ch.2 Start`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Wind M`}</strong>{`, Buy `}<strong parentName="p">{`Thunder M + Thunder L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Quiz Option 2 x3`}<br parentName="p"></br>{`
`}{`After Quiz head to Bolderfall`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <h4 {...{
      "id": "heathecote"
    }}>{`Heathecote`}</h4>
    <p>{`Thunder L + M Stone`}</p>
    <p>{`Steal `}<strong parentName="p">{`Nourishing S & Pom S`}</strong><br parentName="p"></br>{`
`}{`Head towards `}<strong parentName="p">{`Duskbarrow`}</strong>{`.`}</p>
    <p>{`Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{`, Pick `}<strong parentName="p">{`Olive L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`S&Q. Pick `}<strong parentName="p">{`Copper-Filled Pouch`}</strong>{`. Enter `}<strong parentName="p">{`Duskbarrow`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Curious Antique`}</strong>{`. Buy `}<strong parentName="p">{`2 Healing Grape Bunch`}</strong>{` from shop. Pick `}<strong parentName="p">{`$30000`}</strong>{`, pick `}<strong parentName="p">{`Curious Antique`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`. Head to Purgation.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light M`}</strong>{` if no M Stones.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`Forbidden Dagger`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Sunshade`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <h4 {...{
      "id": "helgenish"
    }}>{`Helgenish`}</h4>
    <p>{`Light L + M Stone`}</p>
    <p>{`Go towards Apothecary Shrine`}</p>
    <p>{`Get `}<strong parentName="p">{`Apothecary Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Farshore`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Ice L`}</strong>{`, `}<strong parentName="p">{`$30000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Quarrycrest`}</strong></p>
    <h3 {...{
      "id": "cyrus-ch2-continued"
    }}>{`Cyrus Ch.2 Continued`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold`}</li>
        <li parentName="ul">{`Tressa: Hired Help`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive`}</li>
        <li parentName="ul">{`Prim: `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "gideon"
    }}>{`Gideon`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
      <li parentName="ul">{`Merchants: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Merchants: HHV x3`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Empowering Bracelet`}</strong>{`, Scrut `}<strong parentName="p">{`Curious Antique`}</strong>{`, buy `}<strong parentName="p">{`Empowering Ring`}</strong>{`. Pick `}<strong parentName="p">{`Curious Antique`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch3"
    }}>{`Cyrus Ch.3`}</h3>
    <p>{`Do scruts.`}<br parentName="p"></br>{`
`}{`On Second Screen`}<br parentName="p"></br>{`
`}{`Allure `}<strong parentName="p">{`guy by church for quest (42%)`}</strong>{`. Do this first so if you fail you can reload autosave.`}<br parentName="p"></br>{`
`}{`Buy 2 Silver Armor from weapon shop, attach to Therion + Primrose`}<br parentName="p"></br>{`
`}{`Sell all gold items, Forbidden Dagger + Gideon's Dagger, Refreshing Jam + Olive L`}<br parentName="p"></br>{`
`}{`Buy Fire L from Tobias`}</p>
    <p>{`Screen before Manse`}<br parentName="p"></br>{`
`}{`Talk to guy by fountain to finish quest. (+5k, Royal Crest)`}<br parentName="p"></br>{`
`}{`Buy Light L & Shadow L`}</p>
    <p>{`Menu time!`}<br parentName="p"></br>{`
`}{`Note that this still needs work, not sure what's optimal.`}</p>
    <p>{`Equipment`}<br parentName="p"></br>{`
`}{`Cyrus: Royal Crest`}<br parentName="p"></br>{`
`}{`Tressa: Empowering Ring`}<br parentName="p"></br>{`
`}{`Primrose: Empowering Bracelet`}</p>
    <p>{`Jobs`}<br parentName="p"></br>{`
`}{`Tressa: Sidestep, Warrior, Incite + Thousand Spears`}<br parentName="p"></br>{`
`}{`Therion: Shackle Foe, Apothecary (for HP)`}</p>
    <p>{`Skills`}<br parentName="p"></br>{`
`}{`Tressa: Cover`}</p>
    <p>{`Items`}<br parentName="p"></br>{`
`}{`Nourishing S Therion`}<br parentName="p"></br>{`
`}{`Heal party with grapes`}</p>
    <p>{`Save before Yvon.`}</p>
    <p>{`Yvon`}<br parentName="p"></br>{`
`}{`This is basically pray for no Tornado or double tap. By far worst part of the run. Good luck :)`}<br parentName="p"></br>{`
`}{`T1 you want to increase def / shackle Yvon. HHM is best. Based off who goes first. Unless you know no one will die you want to break T2.`}</p>
    <p>{`T1`}<br parentName="p"></br>{`
`}{`Cyrus: LB / Defend / Leghold Yvon`}<br parentName="p"></br>{`
`}{`Tressa/Prim: HHM / HHB x2 / Defend`}<br parentName="p"></br>{`
`}{`Therion: Shackle Yvon / Defend`}</p>
    <p>{`T2 & 3`}<br parentName="p"></br>{`
`}{`Break Yvon + Adds, throw 3 L Stones.`}<br parentName="p"></br>{`
`}{`If possible boost Corrosive T3 (can Pom S to setup).`}<br parentName="p"></br>{`
`}{`You'll have dead turns here almost always.`}<br parentName="p"></br>{`
`}{`You can recover a character dying T1 if they already had their action.`}</p>
    <p>{`T4`}<br parentName="p"></br>{`
`}{`Cyrus: Staff x4`}<br parentName="p"></br>{`
`}{`Tressa: Defend`}<br parentName="p"></br>{`
`}{`Therion: Corrosive / Attack`}<br parentName="p"></br>{`
`}{`Prim: Attack / Defend`}</p>
    <p>{`T5`}<br parentName="p"></br>{`
`}{`Merchants: HHV x4`}</p>
    <p>{`Allure True Believer `}{`[Stab]`}{` (guy to your right by inn)`}<br parentName="p"></br>{`
`}{`Finish Ch3, TP Duskbarrow`}</p>
    <p>{`In dungeon:`}<br parentName="p"></br>{`
`}{`(I'm not sure on the best way to do this to reduce risk of encounter)`}<br parentName="p"></br>{`
`}{`Pick $50000. Pick $20000, Shadow L.`}</p>
    <p>{`Pick HGB, Pom L`}<br parentName="p"></br>{`
`}{`Pick Ice L, Knight Shield`}</p>
    <p>{`Menu time again`}<br parentName="p"></br>{`
`}{`Equipment`}<br parentName="p"></br>{`
`}{`Prim: Unequip`}<br parentName="p"></br>{`
`}{`Tressa: Swap Ring for Bracelet`}<br parentName="p"></br>{`
`}{`Prim: Optimize, Ring`}</p>
    <p>{`Jobs`}<br parentName="p"></br>{`
`}{`Cyrus: Apothecary, 3 skills, Hunter`}<br parentName="p"></br>{`
`}{`Tressa: Apothecary, 3 skills, Warrior`}<br parentName="p"></br>{`
`}{`Prim: Apothecary, 3 skills, Merchant`}<br parentName="p"></br>{`
`}{`Therion: Apothecary, 3 skills`}</p>
    <p>{`Skills`}<br parentName="p"></br>{`
`}{`All: H&H`}<br parentName="p"></br>{`
`}{`Therion: Incidental Attack`}</p>
    <p>{`Heal all with grapes`}<br parentName="p"></br>{`
`}{`Need at least 90150$ for fight. Should have $90000 - $93500, depending on battles killed & HH usage vs Yvon.`}</p>
    <p>{`Lucia`}<br parentName="p"></br>{`
`}{`Need anyone but Cyrus before Lucia.`}</p>
    <p>{`Prim OR Therion before Lucia`}<br parentName="p"></br>{`
`}{`T1`}<br parentName="p"></br>{`
`}{`Pr HHM / HGB`}<br parentName="p"></br>{`
`}{`Cy Leghold x2`}<br parentName="p"></br>{`
`}{`Th Shackle / HGB`}<br parentName="p"></br>{`
`}{`Tr Incite x2 `}{`[29]`}</p>
    <p>{`T2`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr TS`}<br parentName="p"></br>{`
`}{`Th Shackle / HGB`}<br parentName="p"></br>{`
`}{`Pr HHM / HGB `}{`[23]`}</p>
    <p>{`T3`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr Sidestep x2`}<br parentName="p"></br>{`
`}{`Th HGB`}<br parentName="p"></br>{`
`}{`Pr Pom L Tressa `}{`[20]`}</p>
    <p>{`T4`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr Sidestep x4`}<br parentName="p"></br>{`
`}{`Th AC x2`}<br parentName="p"></br>{`
`}{`Pr Summon `}{`[16]`}{` or Attack if 1 bonus hit (19 Shields start of turn)`}</p>
    <p>{`T5`}<br parentName="p"></br>{`
`}{`Cy Axe x4`}<br parentName="p"></br>{`
`}{`Tr TS`}<br parentName="p"></br>{`
`}{`Th Defend`}<br parentName="p"></br>{`
`}{`Pr Attack x4 `}{`[4]`}</p>
    <p>{`T6`}<br parentName="p"></br>{`
`}{`Th Attack x4 `}{`[0]`}<br parentName="p"></br>{`
`}{`Merchant 1 Pom L Merchant 2`}<br parentName="p"></br>{`
`}{`Merchant 2 HHV x3`}<br parentName="p"></br>{`
`}{`Cy L Stone`}</p>
    <p>{`T7`}<br parentName="p"></br>{`
`}{`Th & Cy L Stone`}<br parentName="p"></br>{`
`}{`Merchants HHV x4`}</p>
    <hr></hr>
    <p>{`Prim & Therion before Lucia (can adjust this to be more like Prim OR Therion). Probably don't boost HHM T1 & do another HHM T2.`}<br parentName="p"></br>{`
`}{`Benefit would be less likely to need Summon. Downside would be more risk of crit messing things up.`}<br parentName="p"></br>{`
`}{`T1`}<br parentName="p"></br>{`
`}{`Th Shackle`}<br parentName="p"></br>{`
`}{`Pr HHM x2`}<br parentName="p"></br>{`
`}{`Cy Leghold x2`}<br parentName="p"></br>{`
`}{`Tr Incite x2 `}{`[28]`}</p>
    <p>{`T2`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr TS`}<br parentName="p"></br>{`
`}{`Th HGB`}<br parentName="p"></br>{`
`}{`Pr Pom L Tressa `}{`[22]`}</p>
    <p>{`T3`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr Sidestep x2`}<br parentName="p"></br>{`
`}{`Th HGB`}<br parentName="p"></br>{`
`}{`Pr Summon `}{`[18]`}{` or Attack if 2 bonus hits (20 Shields start of turn)`}</p>
    <p>{`T4`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr Sidestep x4`}<br parentName="p"></br>{`
`}{`Th AC x2`}<br parentName="p"></br>{`
`}{`Pr Attack `}{`[13]`}</p>
    <p>{`T5`}<br parentName="p"></br>{`
`}{`Cy Axe x4`}<br parentName="p"></br>{`
`}{`Tr TS`}<br parentName="p"></br>{`
`}{`Th Defend`}<br parentName="p"></br>{`
`}{`Pr Attack x2 `}{`[3]`}</p>
    <p>{`T6`}<br parentName="p"></br>{`
`}{`Th Attack x3 `}{`[0]`}<br parentName="p"></br>{`
`}{`Merchant 1 Pom L Merchant 2`}<br parentName="p"></br>{`
`}{`Merchant 2 HHV x3`}<br parentName="p"></br>{`
`}{`Cy L Stone`}</p>
    <p>{`T7`}<br parentName="p"></br>{`
`}{`Th & Cy L Stone`}<br parentName="p"></br>{`
`}{`Merchants HHV x4`}</p>
    <hr></hr>
    <p>{`Only Tressa before Lucia`}<br parentName="p"></br>{`
`}{`T1`}<br parentName="p"></br>{`
`}{`Tr HHM`}<br parentName="p"></br>{`
`}{`Th HGB`}<br parentName="p"></br>{`
`}{`Pr HGB`}<br parentName="p"></br>{`
`}{`Cy Leghold x2 `}{`[29]`}</p>
    <p>{`T2`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr Incite x2`}<br parentName="p"></br>{`
`}{`Th Shackle`}<br parentName="p"></br>{`
`}{`Pr Summon `}{`[25]`}</p>
    <p>{`T3`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr Sidestep x2`}<br parentName="p"></br>{`
`}{`Th HGB`}<br parentName="p"></br>{`
`}{`Pr Pom L Tressa `}{`[21]`}</p>
    <p>{`T4`}<br parentName="p"></br>{`
`}{`Cy RoA`}<br parentName="p"></br>{`
`}{`Tr Sidestep x4`}<br parentName="p"></br>{`
`}{`Th AC x2`}<br parentName="p"></br>{`
`}{`Pr Attack `}{`[16]`}</p>
    <p>{`T5`}<br parentName="p"></br>{`
`}{`Cy Axe x4`}<br parentName="p"></br>{`
`}{`Tr TS`}<br parentName="p"></br>{`
`}{`Th Defend`}<br parentName="p"></br>{`
`}{`Pr Attack x4 `}{`[4]`}</p>
    <p>{`T6`}<br parentName="p"></br>{`
`}{`Th Attack x4 `}{`[0]`}<br parentName="p"></br>{`
`}{`Merchant 1 Pom L Merchant 2`}<br parentName="p"></br>{`
`}{`Merchant 2 HHV x3`}<br parentName="p"></br>{`
`}{`Cy L Stone`}</p>
    <p>{`T7`}<br parentName="p"></br>{`
`}{`Th & Cy L Stone`}<br parentName="p"></br>{`
`}{`Merchants HHV x4`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      